/* eslint-disable no-param-reassign */
import React, { useEffect, useState } from 'react';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { useParams } from '@thd-olt-component-react/router';
import { useStore } from '@thd-nucleus/experience-context';
import { ProductReviews } from './ProductReviews';

export const ProductReviewsContainer = () => {
  const store = useStore();
  const { storeId } = store || {};
  const { isCustomerIdentified = false } = useThdCustomer();
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const { page } = useParams();
  const pageNumber = page === undefined ? '1' : page;
  let startIndex = (pageNumber - 1) * 30 || 1;
  startIndex = Number(pageNumber) > 1 ? startIndex + 1 : startIndex;

  const reviewsDefaultVariables = {
    storeId,
    excludeFamily: false,
    pagesize: '30',
    recfirstpage: '30',
    sortBy: 'photoreview',
    searchTerm: null,
    skipPaintDetails: true,
    startIndex,
    filters: {
      isVerifiedPurchase: false,
      prosCons: null,
      starRatings: null
    },
    isBrandPricingPolicyCompliant: isMounted ? isCustomerIdentified : false,
  };

  const queryOptions = ({ options, queryName }) => {

    if (queryName === 'product') {
      delete options.variables.storeId;
      return {
        ...options,
        variables: {
          ...options.variables,
        },
      };
    }

    return options;
  };

  return (
    <QueryProvider
      queryOptions={queryOptions}
      cacheKey="paginated-product-reviews"
      defaultVariables={reviewsDefaultVariables}
    >
      <ProductReviews />
    </QueryProvider>
  );
};
